<template>
    <div class="size-auto md:p-4">
        <Logo class="!h-full !w-full" :compact />
    </div>
</template>

<script setup lang="ts">
    import Logo from '@cirqll/storybook/components/partial/Logo';
    import { useSize } from '~/composable/use_size';

    const size = useSize();

    const props = withDefaults(defineProps<{
        /** Use small logo when device is a mobile phone */
        smallOnMobile?: boolean;
    }>(), { smallOnMobile: false });

    const compact = computed(() => props.smallOnMobile ? size.smaller.lg : false);
</script>

<style scoped></style>
